export default __webpack_public_path__ + "static/media/section2-bg4-h5.598de7cb.png";